import Templates from '@elisa-luukku-sites/cms-templates';
import type { ContentBlock } from '../../generated/api/contentBlock.js';
import type { ArticleBodyProps } from '@elisa-luukku-sites/cms-templates/types/src/templates/ArticleBody/types.js';

const { ArticleBody } = Templates.default;

const ideatContentBlockComponents = {
  articleBody: ({ content }: { content: ArticleBodyProps }) => <ArticleBody {...content} />,
};

type IdeatContentBlockType = keyof typeof ideatContentBlockComponents;

const IdeatContentBlock = ({ contentBlockType, fields }: ContentBlock) => {
  const contentBlockTypeLowerCase = contentBlockType.toLowerCase();
  const name = (Object.keys(ideatContentBlockComponents) as IdeatContentBlockType[]).find(
    key => `cb-${key.toLowerCase()}` === contentBlockTypeLowerCase // articleBody from ideatContentBlockComponents
  );
  if (!name) {
    return null;
  }
  const Component = ideatContentBlockComponents[name];
  return <Component content={fields as ArticleBodyProps} />;
};

export const IdeatContentBlocks = ({ contentBlocks }: { contentBlocks: ContentBlock[] }) => (
  <>
    {contentBlocks.map((contentBlock, index) => (
      <IdeatContentBlock key={`ideat-content-block-${contentBlock.contentBlockId}-${index}`} {...contentBlock} />
    ))}
  </>
);
